



















import { Vue, Component } from 'vue-property-decorator'

@Component
export default class EkycWaiting extends Vue {
  checkInterval: any = null
  maxChecks = 60 // 5 minutes with 5-second intervals
  currentChecks = 0

  get formUrl(): string {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('form_url') || ''
  }

  async mounted() {
    // Get query parameters
    const urlParams = new URLSearchParams(window.location.search)
    const challenge = urlParams.get('challenge') || ''
    const formUrl = urlParams.get('form_url') || ''

    if (!challenge) {
      console.error('No challenge parameter found')
      return
    }

    // Open form URL in new tab if provided
    if (formUrl) {
      window.open(formUrl, '_blank')
    }

    // Start checking eKYC status
    this.startStatusCheck()
  }

  beforeDestroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
    }
  }

  async startStatusCheck() {
    this.checkInterval = setInterval(async () => {
      await this.checkStatus()
      this.currentChecks++

      if (this.currentChecks >= this.maxChecks) {
        this.stopChecking()
        console.error('KYC check timeout')
      }
    }, 5000) // Check every 5 seconds

    // Initial check
    await this.checkStatus()
  }

  async checkStatus() {
    try {
      // Get challenge from query parameters
      const urlParams = new URLSearchParams(window.location.search)
      const challenge = urlParams.get('challenge')

      const resp = await fetch(`/api/ekyc-status?challenge=${challenge}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })

      if (resp.status > 400) {
        console.error('KYC status check failed')
        return
      }

      const result = await resp.json()

      if (result && result.data && result.data.status === 'COMPLETE') {
        this.stopChecking()

        // Redirect to consent page
        const urlParams = new URLSearchParams(window.location.search)
        const challenge = urlParams.get('challenge')
        const redirectUrl = urlParams.get('redirect_url')

        if (redirectUrl && challenge) {
          window.location.href = `${redirectUrl}?consent_challenge=${challenge}`
        } else {
          window.location.href = '/consent'
        }
      }
    } catch (error) {
      console.error('Error checking eKYC status:', error)
    }
  }

  stopChecking() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval)
      this.checkInterval = null
    }
  }
}
